import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=17d7bdea&scoped=true"
import script from "./article-detail.vue?vue&type=script&lang=ts"
export * from "./article-detail.vue?vue&type=script&lang=ts"
import style0 from "./article-detail.vue?vue&type=style&index=0&id=17d7bdea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7bdea",
  null
  
)

export default component.exports